import React from 'react';
import './PlayersGridItem.css';
import { getPlayerHeight } from '../../../../utils';

const PlayersGridItem = ({ id, data, enableSorting }) => (
  <div className="player-grid-item" style={ enableSorting ? {cursor: 'move'} : {} }>
    { enableSorting &&
      <div className="pull-right hidden-print">
        <button type="button"
                className="btn btn-remove-player">
          <span className="glyphicon glyphicon-remove remove-player"
                aria-hidden="true"
                id={ `btn_remove_player_${id}` }></span>
        </button>
      </div>
    }
    <div className="player-header"
          title={ `${data.lastName} ${data.firstName}`}>
      <div className="player-name">
        { `${data.lastName} ` }
        { data.firstName ?
          `${data.firstName[0]}.` :
          '' }
      </div>
    </div>
    {/* /.player-header */}
    <div className="player-body">
      <div className="player-photo">
        <img src={ (data.profilePhoto && data.profilePhoto !== '') ? data.profilePhoto
                     : `https://s3.amazonaws.com/s4usitesimages/images/anon-avatar.png` }
             alt={ data.lastName } />
      </div>
      <div className="player-info">
        <div>
          { data.position ?
            `${data.position.shortName}, ` :
            '' }
          { data.height ?
            `${getPlayerHeight(data.height)} ` :
            '' }
        </div>
        <div>
          { data.jerseyNumber >= 0 &&
            <span>#{ data.jerseyNumber } </span>
          }
          { data.mainNationality &&
            <span title={ data.mainNationality.name }>
              { data.mainNationality.shortName }
            </span>
          }
        </div>
      </div>
      {/* /.player-info */}
    </div>
    {/* /.player-body */}
  </div>
);

export default PlayersGridItem;



// WEBPACK FOOTER //
// ./src/features/scout-report/components/PlayersGridItem/PlayersGridItem.js